import { Badge } from '@/components/ui/badge';
import { normalizeCriticality, getCriticalityColor } from '@/lib/utils';

interface CriticalityBadgeProps {
  value: string | undefined | null;
  className?: string;
}

export function CriticalityBadge({ value, className }: CriticalityBadgeProps) {
  const normalized = normalizeCriticality(value);
  
  if (!normalized) {
    return <span className="text-sm text-muted-foreground">-</span>;
  }
  
  return (
    <Badge 
      variant="outline" 
      className={`${getCriticalityColor(value)} ${className || ''}`}
    >
      {normalized}
    </Badge>
  );
}
